/**
 * @generated SignedSource<<5dfaa34b7219a07cbc979b6c6f12bbdc>>
 * @relayHash f56aed5cfb9b7e0742abb263e50fa834
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69e3f185edb308830fff1d615d0ffd8ed47d44311e1dc352508478acfa1c648b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type csmRequestsListQuery$variables = {
  accountId: string;
  cloudId: string;
};
export type csmRequestsListQuery$data = {
  readonly customerService: {
    readonly individualByAccountId: {
      readonly __typename: "CustomerServiceIndividual";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type csmRequestsListQuery = {
  response: csmRequestsListQuery$data;
  variables: csmRequestsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "individualByAccountId",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "CustomerServiceIndividual"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.individualByAccountId"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "69e3f185edb308830fff1d615d0ffd8ed47d44311e1dc352508478acfa1c648b",
    "metadata": {},
    "name": "csmRequestsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "99f711499f2e59fb76efca11ad86c0b0";

export default node;
